import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { RouteNotFound } from 'components/404'
import Schedule, { DeprecatedSchedule } from './Schedule'

export const appName = 'schedule'

export const App = () => {
  const isMpNewSchedulerPageEnabled = useFeatureFlag('mpNewSchedulerPage')

  return (
    <AppWrap appName={appName} title='Scheduler'>
      <Switch>
        <Route
          exact
          path='/'
          component={isMpNewSchedulerPageEnabled ? Schedule : DeprecatedSchedule}
        />
        <Route component={RouteNotFound} />
      </Switch>
    </AppWrap>
  )
}
